export const homePath = "/";

// auth / setup
export const forbiddenPath = "/403";
export const notFoundPath = "/404";
export const serverErrorPath = "/500";
export const authErrorPath = "/512";
export const verifyPath = "/verify";
export const setupPath = (redirect: string) => `/setup?redirect=${redirect}`;
export const loginPath = (redirect: string) => `/api/auth/login?redirect=${redirect}`;
// export const registerPath = (redirect: string) =>
//   `/api/auth/login?redirect=${redirect}&hint=signup`;
export const logoutPath = "/api/auth/logout";

// users
export const userPath = (id: string) => `/users/${id}`;

// decks
export const decksPath = "/decks";
export const deckPath = (id: string) => `/decks/${id}`;
export const preconsPath = "/precons";
export const preconPath = (id: string) => `/precons/${id}`;

// cards
export const cardsPath = "/cards";
export const cardPath = (slug: string) => `/cards/${slug}`;

// collection
export const collectionPath = "/collection";
// export const collectionItemPath = (id: string) => `/collection/${id}`;
export const collectionGuidePath = "/collection/guide";

// misc
export const ogPath = (
  src: string,
  rotate: number, // rotate is 1 if needs it, 0 if not
) => `/api/og?src=${src}&rotate=${rotate}`;
export const faqsPath = "/faqs";
export const codexesPath = "/codex";
export const codexPath = (id: string) => `/codex?codex=${id}`;
export const contactPath = "/contact";

// external
export const websitePath = "https://sorcerytcg.com";
export const newsPath = "https://sorcerytcg.com/news";
export const playNetworkPath = "https://play.sorcerytcg.com";
export const locatorPath = "https://sorcerytcg.com/locator";
export const rulebookPath =
  "https://drive.google.com/file/d/1sgQo0xf0N2teIR0zlyl91g9j6LVncZnr/view";
export const discordGroupPath = "https://discord.gg/qvYVGFAS5n";
export const fbGroupPath = "https://www.facebook.com/groups/sorceryofficial";
export const apiPath = "https://api.sorcerytcg.com";
export const termsPath = "https://sorcerytcg.com/terms";
